import client from './client'

export const login = async (email, password) => {
  const response = await client.post('/auth/login', { email, password })
  return response.data
}

export const register = async (username, email, password, accountType = 'warehouse') => {
  const response = await client.post('/auth/register', { username, email, password, account_type: accountType })
  return response.data
}

export const getMe = async () => {
  const response = await client.get('/auth/me')
  return response.data
}

export const switchAccount = async (accountId) => {
  const response = await client.post('/auth/switch-account', { account_id: accountId })
  return response.data
}
